export default "__VITE_ASSET__B8jYJeIZ__"